import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import {
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<{
      gestionFinanciere: 'GESTION_PAR_ADHERENT' | 'GESTION_DELEGUEE';
    }> = {
      gestionFinanciere: [
        parameters?.gestionFinanciere || null,
        Validators.required,
      ],
    };
    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as FormArray;
  }

  extract() {
    return { ...this.form.value };
  }
}
